// extracted by mini-css-extract-plugin
export default {"width_xxs":"320","width_xs":"576","width_md":"768","width_lg":"992","width_xl":"1200","width_xxl":"1400","width_xxxl":"1920"};